/**
 * Polls the given function with limitied number of attempts
 * respecting the given interval
 * @param {Function<Promise>} factoryFn
 * @param {Function<Boolean>} checkConditionFn
 * @param {Number} interval
 * @param {Number} tries
 */
export default function poll(factoryFn, checkConditionFn, interval = 1000, tries = 5) {
    let attempts = 0;
    const isAnotherPollNeeded = () => attempts < tries;
    const executePoll = (resolve, reject) => {
        factoryFn()
            .then((response) => {
                if (checkConditionFn(response)) {
                    resolve(response);
                } else if (isAnotherPollNeeded()) {
                    attempts += 1;
                    setTimeout(executePoll, interval, resolve, reject);
                } else {
                    reject(new Error(`Failed to poll with a function ${factoryFn}`));
                }
            })
            .catch(reject);
    };

    return new Promise(executePoll);
}
